import { Box } from '@material-ui/core'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { Button, Error, FormattedText, Loader } from 'src/modules/core/components'
import { useUserPreferences } from 'src/modules/preferences/hooks/use-user-preferences'
import { ConfigurationForm, ProfileInfo } from 'src/modules/user/components'
import { useProfile } from 'src/modules/user/hooks/use-profile'
import { useTrack } from 'src/modules/user/hooks/use-track'
import classes from './first-configuration-screen.module.scss'

export function FirstConfigurationScreen() {
  const profile = useProfile()
  const preferences = useUserPreferences()
  const track = useTrack()
  const [hasTrackedEvent, setHasTrackedEvent] = useState(false)

  useEffect(() => {
    if (!profile.isLoading && profile.data && !hasTrackedEvent) {
      track.mutate({ event: 'onboarding_start' })
      setHasTrackedEvent(true)
    }
  }, [profile.isLoading, profile.data, hasTrackedEvent, track])

  function handleRetry() {
    profile.refetch()
    preferences.refetch()
  }

  if (profile.isLoading || preferences.isLoading) {
    return <Loader isLoading text={<FormattedText id="configuration.profileLoadingText" />} full />
  }

  // React Query v3 clears `isLoading` on error while leaving `data` undefined,
  // so without this branch a failed profile fetch renders a blank onboarding
  // screen and the form crashes on the first `profile.usage_mode` read.
  if (!profile.data || !preferences.data) {
    return (
      <div className={classNames(classes.root, classes.text)}>
        <Error text={<FormattedText id="configuration.profileLoadError" />} />
        <Box display="flex" justifyContent="center" marginTop={3}>
          <Button widthType="content" onClick={handleRetry} isLoading={profile.isFetching || preferences.isFetching}>
            <FormattedText id="common.tryAgain" />
          </Button>
        </Box>
      </div>
    )
  }

  return (
    <div className={classNames(classes.root)}>
      <ConfigurationForm profile={profile.data} preferences={preferences.data} />
      <ProfileInfo rootClassName={classes.absoluteWrapper} />
    </div>
  )
}
